import axios, { AxiosRequestConfig } from "axios";

import { DictionaryList } from "src/redux/dictionary/types";
import { ApiResponse } from "src/types";
import { API_URLS } from "src/utils/API_URLS";

const DictionariesService = {
  getList: async (
    wsDictionaryUuid: string,
    config?: AxiosRequestConfig,
  ): Promise<DictionaryList> => {
    try {
      const url = API_URLS.getDictionaryList.replace(
        ":dictionaryUuid:",
        wsDictionaryUuid,
      );
      const response = await axios.get<ApiResponse<DictionaryList>>(
        url,
        config,
      );
      return response.data.content;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default DictionariesService;
